import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './youtube1440px.module.scss';
import FooterButton from '../Footer/components/FooterButton/FooterButton';

const YouTubeBlock: NextPage = () => {
  return (
    <section className="container">
      <div className={[styles.youtube1440px].join(' ')}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.icontext}>
              <Image
                className={styles.mdiyoutubeIcon}
                loading="lazy"
                width={80}
                height={80}
                sizes="100vw"
                alt=""
                src="/img/youtubeBlock/youtube-img.svg"
              />
              <h2 className={styles.title}>
                <span className={styles.seeAFewFleet}>
                  See a few Fleet Videos on YouTube
                </span>
              </h2>
            </div>
            <a
              href="https://www.youtube.com/@heraflight"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FooterButton
                color="accent"
                highContrast={false}
                loading={false}
                size={3}
                state="default ✦"
                variant="solid ✦"
                text="Go to YouTube Channel"
                iconStart={false}
                iconEnd={false}
                focusRing={false}
                // href="https://www.youtube.com/@heraflight"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouTubeBlock;
